import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PpcEyebrow } from '@design-system/eyebrow/eyebrow';
import { PpcHeading } from '@design-system/heading/heading';

@Component({
  selector: 'app-faq',
  imports: [TranslatePipe, PpcEyebrow, PpcHeading],
  templateUrl: './faq.html',
  styleUrl: './faq.css',
})
export class FaqComponent {
  private readonly translate = inject(TranslateService);

  private readonly SIGN_OPEN = '—';
  private readonly SIGN_CLOSED = '+';
  private readonly NUMBER_PREFIX = '0';

  private readonly open = signal(0);

  private readonly rawEntries = toSignal(this.translate.stream('faq'), {
    initialValue: [] as { q: string; a: string }[],
  });

  protected readonly entries = computed(() =>
    this.rawEntries().map((entry: { q: string; a: string }, index: number) => ({
      number: `${this.NUMBER_PREFIX}${index + 1}`,
      question: entry.q,
      answer: entry.a,
      isOpen: this.open() === index,
      sign: this.open() === index ? this.SIGN_OPEN : this.SIGN_CLOSED,
    })),
  );

  protected toggle(index: number) {
    this.open.update((current) => (current === index ? -1 : index));
  }
}
